export default "__VITE_ASSET__B1s6J5Fm__"